"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datasetItemFilterColumns = void 0;
exports.datasetItemFilterColumns = [
    {
        name: "Metadata",
        id: "metadata",
        type: "stringObject",
        internal: 'di."metadata"',
    },
];
